<div class="admin_card add_student">
    <div class="subscribe_form student-addition">

      <div class="add_student-form-main">
     <div class="row justify-content-center">
     <div class="col-sm-11">
     <form  [formGroup]="form" (submit)="onSubmit($event)"
     class="parents_registration_form-main student-1 add_student-form">

<mat-horizontal-stepper>
<mat-step
 *ngFor="let field of fields; let index = index; let last = last"
>
<div class="col-lg-5">
<ng-template matStepperIcon="edit">
 <mat-icon>done</mat-icon>
</ng-template>
</div>
<ng-template matStepLabel>{{ field.label }}</ng-template>

<div class="row justify-content-center">
<div class="col-md-12">
<ng-container  dynamicField [field]="field.fields" [group]="form">

</ng-container>
<div style="display: flex; flex-direction: row; justify-content: center; align-items: center;" class="mt-3">
<button
 *ngIf="index !== 0"
 matStepperPrevious
 class="btn btn-primary"
 type="button"
 (click)="prevStep(index)"
>
 Back
</button>
<button
 *ngIf="!last"
 matStepperNext
 class="btn btn-primary"
 type="button"

 (click)="nextStep(index)"
>
 Next
</button>
<button
 *ngIf="last"
 class="btn btn-primary"
 type="submit"
>
 Submit
</button>
</div>
</div>
</div>
 </mat-step>
 </mat-horizontal-stepper>
 </form>
     </div>
     </div>
      </div>
    </div>
  </div>
